export default __webpack_public_path__ + "static/media/list.ee665023.svg";